import { SET_SUBMITS_BLOCK } from 'root/src/client/logic/form/actionIds'

export default payload => ({
	type: SET_SUBMITS_BLOCK,
	payload,
})
